<template>
  <v-card class="mt-4 mx-auto">
    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      />
    </v-overlay>
    <v-sheet
      class="v-sheet--offset mx-auto"
      color="success"
      elevation="12"
      max-width="calc(100% - 32px)"
    >
      <v-card
        dark
        color="color_green"
      >
        <v-card-title> Global Layers </v-card-title>
      </v-card>
    </v-sheet>
    <v-card-text class="pt-0">
      <v-data-table
        id="services-table"
        :headers="layers.headers"
        :items="layers.globalLayers"
        :search="search"
        :loading="loading"
        class="elevation-1"
      >
        <template v-slot:top>
          <v-toolbar
            flat
            color="white"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            />
            <v-spacer />
            <v-btn
              color="color_green"
              dark
              @click="createButtonEvent"
            >
              New Layer
            </v-btn>
          </v-toolbar>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            small
            class="mr-2"
            @click="editButtonEvent(item)"
          >
            mdi-pencil
          </v-icon>
          <v-icon
            small
            @click="translationButtonEvent(item)"
          >
            mdi-google-translate
          </v-icon>
          <delete
            :id="item.name"
            @deleted="deleteButtonEvent(item)"
          />
        </template>
        <template v-slot:no-data>
          <span color="primary">No data to show you</span>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    delete: () => import('@/components/utils/Delete')
  },

  data() {
    return {
      search: '',
      loading: false,
      overlay: false
    };
  },
  computed: {
    ...mapState(['layers'])
  },
  async mounted() {
    this.loading = true;
    await this.storeGlobalLayers();
    this.loading = false;
  },
  methods: {
    ...mapActions(['storeGlobalLayers', 'deleteGlobalLayerAction']),
    async deleteButtonEvent(item) {
      this.overlay = true;
      await this.deleteGlobalLayerAction(item.global_layer_id);
      this.overlay = false;
      this.storeGlobalLayers();
    },
    editButtonEvent(item) {
      this.$emit('editLayerEvent', item);
    },
    createButtonEvent() {
      this.$emit('createLayerEvent');
    },
    translationButtonEvent(item) {
      this.$emit('translationLayerEvent', item);
    }
  }
};
</script>

<style>
.v-sheet--offset {
  top: -24px;
  position: relative;
}
</style>
